import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { AppDataConsumer, AppDataProvider } from "./common/appContext";
import Helper from "./common/Helper";
import RouteConstants from "./common/RouteConstants";
import { loginRequest } from "./configs/authConfig";
import { Role } from "./helper";
import AdminPreferences from "./screens/adminPreferences/AdminPreferences";
import AdminBallotDashboard from "./screens/ballotDashboard/AdminBallotDashboard";
import TeamBallotDashboard from "./screens/ballotDashboard/TeamBallotDashboard";
import TeamGreenBallotVote from "./screens/ballotDashboard/TeamGreenRoomBallotVote";
import CombineResults from "./screens/combineResults/CombineResults";

import ComparePlayerStats from "./screens/compareStats/";
import GameAuditContainer from "./screens/gameAudit/GameAuditContainer";
///import screen containers
import HomeContainer from "./screens/home/HomeContainer";
// import useToken from "./screens/login/useToken.js";
import Login from "./screens/login/Login.js";
import Logout from "./screens/login/logout";
import ManagePlayerCareerStatsContainer from "./screens/ManagePlayerCareerStats/ManagePlayerCareerStatsContainer";
import ManageUsersContainer from "./screens/manageUsers/ManageUsersContainer";
import EditPlayerProfile from "./screens/playerProfiles/EditPlayerProfile";
import PlayerList from "./screens/playerProfiles/PlayerList";
import ViewPlayerProfile from "./screens/playerProfiles/ViewPlayerProfile";
///import screen containers
import { UserDataService } from "./services";
import AppHeaderBar from "./sharedComponents/appHeaderBar/AppHeaderbar";
import ErrorBoundary from "./sharedComponents/errorBoundary/ErrorBoundary";
import { PrivateRoute } from "./sharedComponents/PrivateRoute";
import SidebarMenu from "./sharedComponents/SidebarMenu/SidebarMenu";
import Unauthorized from "./sharedComponents/unauthorized";
import ComparePlayers from "./screens/comparePlayers/ComparePlayers";
import ManageUserPreferences from "./screens/userPreferences/ManageUserPreferences";
import RevisedGameAuditContainer from "./screens/revisedGameAudit/RevisedGameAuditContainer";
import GameScoreDashboard from "./screens/boxScore/GameScoreDashboard";

//MODIFIED CAREER STATS SCREEN
import ComparableDashboard from "./screens/careerStatsDashboard/ComparableDashboard";
import EmailNotification from "./screens/emailNotification/EmailNotification";
import ManageEmailNotification from "./screens/emailNotification/ManageEmailNotification";
import ViewEmailNotification from "./screens/emailNotification/ViewEmailNotification";
import GLeagueBallot from "./screens/ballotDashboard/GLeagueBallot";
import ScrollToTop from "./helper/ScrollToTop";
import ManageTeamPlayersContainer from "./screens/teamPlayersManagement/ManageTeamPlayersContainer";
import EventScheduleContainer from "./screens/eventScheduler/EventScheduleContainer";
import ViewTeamRoster from "./screens/teamRoster/ViewTeamRoster";
import UserManagementContainer from "./screens/userManagement/UserManagementContainer";
import Manage5On5GamesContainer from "./screens/Manage5On5Games/Manage5On5GamesContainer.js";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },

  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "auto",
    height: "100vh",
    // backgroundColor: "#ffffff",
  },
}));

function App() {
  const [themeType, setThemeType] = useState("light");

  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  //... See the theme colors at the bottom of this control.
  const theme = getTheme({
    paletteType: themeType,
  });

  useEffect(() => {
    if (isAuthenticated) {
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          //console.log(response);
          Helper.setStorage("accessToken", response.accessToken);
        });
    }
  }, []);

  useEffect(() => {
    if (instance && accounts[0]) {
      const accessTokenRequest = {
        ...loginRequest,
        account: accounts[0],
      };
      if (inProgress === InteractionStatus.None) {
        instance
          .acquireTokenSilent(accessTokenRequest)
          .then(async (response) => {
            //console.log(response);
            Helper.setStorage("accessToken", response.accessToken);
            Helper.setStorage("chk", "aad");

            if (window.location.pathname.includes("login")) {
              window.location.assign("/");
            }

            // eslint-disable-next-line no-debugger
            // debugger
            //setShowLogin(false);
          })
          .catch((error) => {
            if (error instanceof InteractionRequiredAuthError) {
              instance.acquireTokenRedirect(accessTokenRequest);
            }
          });
      }
    }
  }, [instance, accounts, inProgress]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <AppDataProvider>
            <AppDataConsumer>
              {(props) => {
                return <AppRoute user={props.user} />;
              }}
            </AppDataConsumer>
          </AppDataProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

const AppRoute = (props) => {
  const classes = useStyles();
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [isWebView, setIsWebView] = useState(false);
  let userAppRoles = props.user.appRoles || [];

  const isAdmin = props.user.isAdmin;
  const playerProfileFlag = props.user.playerProfileFlag;
  const combineResultsFlag = props.user.combineResultsFlag;

  // const { token, setToken } = useToken();

  // if (!token) {
  //   return <Login setToken={setToken} />;
  // }

  useEffect(() => {
    if (Helper.getStorage("accessToken") == null) {
      setShowLogin(true);
    }
  }, []);

  useEffect(() => {
    if (props.user) {
      setIsWebView(Helper.detectWebView());
    }
  }, [props.user]);

  const toggleDrawer = (event, open) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpenSideMenu(open);
  };

  function logout() {
    localStorage.clear();
    sessionStorage.clear();
    window.location = props.user.signoutURL;
  }

  return (
    <div className={classes.root}>
      <Router>
        {/* {showLogin &&
          Helper.getStorage("accessToken") == null &&
          Helper.getStorage("chk") == null && <Login setLogin={setShowLogin} />}
        {!showLogin && ( */}
        {/* <> */}

        <ScrollToTop />
        {UserDataService.isUserLoggedIn() && !isWebView && (
          <AppHeaderBar onLogout={logout} toggleDrawer={toggleDrawer} />
        )}

        <div className={classes.container}>
          <Routes>
            <Route
              element={<Login user={props.user} />}
              path={RouteConstants.LOGIN}
            />
            <Route element={<Logout />} path={RouteConstants.LOGOUT} />
            <Route
              path={RouteConstants.HOME}
              element={
                <PrivateRoute
                  roles={[
                    Role.Admin,
                    Role.League,
                    Role.Team,
                    Role.CombineBallotUser,
                    Role.DraftGreenRoomBallotUser,
                  ]}
                />
              }
            >
              <Route path={RouteConstants.HOME} element={<HomeContainer />} />
            </Route>
            <Route
              path={RouteConstants.MANAGE_USERS}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={RouteConstants.MANAGE_USERS}
                element={<ManageUsersContainer />}
              />
            </Route>
            <Route
              path={RouteConstants.GAME_AUDIT}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={RouteConstants.GAME_AUDIT}
                element={<GameAuditContainer />}
              />
            </Route>
            <Route
              path={RouteConstants.TEAM_BALLOT_DASHBOARD}
              element={<PrivateRoute roles={[Role.CombineBallotUser]} />}
            >
              <Route
                path={RouteConstants.TEAM_BALLOT_DASHBOARD}
                element={<TeamBallotDashboard />}
              />
            </Route>
            <Route
              path={RouteConstants.TEAM_GREEN_BALLOT_VOTE}
              element={<PrivateRoute roles={[Role.DraftGreenRoomBallotUser]} />}
            >
              <Route
                path={RouteConstants.TEAM_GREEN_BALLOT_VOTE}
                element={<TeamGreenBallotVote />}
              />
            </Route>
            <Route
              path={RouteConstants.ADMIN_BALLOT_DASHBOARD}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={RouteConstants.ADMIN_BALLOT_DASHBOARD}
                element={<AdminBallotDashboard />}
              />
            </Route>
            {/* <Route
              path={RouteConstants.MANAGEMENT_PERMISSION}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={RouteConstants.MANAGEMENT_PERMISSION}
                element={<AccessManagementContainer />}
              />
            </Route> */}
            <Route
              path={RouteConstants.ADMIN_PREFERENCES}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={RouteConstants.ADMIN_PREFERENCES}
                element={<AdminPreferences />}
              />
            </Route>
            <Route
              path={`/:eventId${RouteConstants.PLAYER_LIST}`}
              element={
                <PrivateRoute
                  roles={[
                    Role.Admin,
                    Role.League,
                    Role.Team,
                    Role.CombineBallotUser,
                    Role.DraftGreenRoomBallotUser,
                  ]}
                />
              }
            >
              <Route
                path={`/:eventId${RouteConstants.PLAYER_LIST}`}
                element={<PlayerList />}
              />
            </Route>
            <Route
              path={RouteConstants.COMPARE_PLAYER_STATS}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={RouteConstants.COMPARE_PLAYER_STATS}
                element={<ComparePlayerStats />}
              />
            </Route>
            <Route
              path={`/:eventId${RouteConstants.EDIT_PLAYER_PROFILE}/:playerId`}
              element={<PrivateRoute roles={[Role.Admin, Role.League]} />}
            >
              <Route
                path={`/:eventId${RouteConstants.EDIT_PLAYER_PROFILE}/:playerId`}
                element={<EditPlayerProfile />}
              />
            </Route>

            {/* <Route
              path={RouteConstants.EDIT_PLAYER_PROFILE}
              element={
                isAdmin ||
                (RoutePermissions.IsAuthorized(
                  RouteScreens.PlayerProfileEdit,
                  userAppRoles
                ) &&
                  playerProfileFlag) ? (
                  <EditPlayerProfile />
                ) : (
                  unauthorized()
                )
              }
            ></Route> */}
            <Route
              path={`/:eventId${RouteConstants.VIEW_PLAYER_PROFILE}/:playerId`}
              element={
                <PrivateRoute
                  roles={[
                    Role.Admin,
                    Role.League,
                    Role.Team,
                    Role.CombineBallotUser,
                    Role.DraftGreenRoomBallotUser,
                  ]}
                  playerProfileFlag={playerProfileFlag}
                />
              }
            >
              <Route
                path={`/:eventId${RouteConstants.VIEW_PLAYER_PROFILE}/:playerId`}
                element={<ViewPlayerProfile />}
              />
            </Route>

            <Route
              path={RouteConstants.VIEW_PLAYER_PROFILE}
              element={
                <PrivateRoute
                  roles={[
                    Role.Admin,
                    Role.League,
                    Role.Team,
                    Role.CombineBallotUser,
                    Role.DraftGreenRoomBallotUser,
                  ]}
                  playerProfileFlag={playerProfileFlag}
                />
              }
            >
              <Route
                path={RouteConstants.VIEW_PLAYER_PROFILE}
                element={<PlayerList />}
              />
            </Route>
            {/* <Route
              path={RouteConstants.VIEW_PLAYER_PROFILE}
              element={
                isAdmin ||
                (RoutePermissions.IsAuthorized(
                  RouteScreens.ViewPlayerProfile,
                  userAppRoles
                ) &&
                  playerProfileFlag) ? (
                  <ViewPlayerProfile />
                ) : (
                  unauthorized()
                )
              }
            ></Route> */}
            <Route
              path={`/:eventId${RouteConstants.COMBINE_RESULTS}`}
              element={
                <PrivateRoute
                  roles={[
                    Role.Admin,
                    Role.League,
                    Role.Team,
                    Role.CombineBallotUser,
                    Role.DraftGreenRoomBallotUser,
                  ]}
                  combineResultsFlag={combineResultsFlag}
                />
              }
            >
              <Route
                path={`/:eventId${RouteConstants.COMBINE_RESULTS}`}
                element={<CombineResults />}
              />
            </Route>

            <Route
              path={`/:eventId${RouteConstants.COMPARE_PLAYERS}`}
              element={
                <PrivateRoute
                  roles={[
                    Role.Admin,
                    Role.League,
                    Role.Team,
                    Role.CombineBallotUser,
                    Role.DraftGreenRoomBallotUser,
                  ]}
                  combineResultsFlag={combineResultsFlag}
                />
              }
            >
              <Route
                path={`/:eventId${RouteConstants.COMPARE_PLAYERS}`}
                element={<ComparePlayers />}
              />
            </Route>
            <Route
              path={`/:eventId${RouteConstants.CAREER_STATS}`}
              element={
                <PrivateRoute
                  roles={[
                    Role.Admin,
                    Role.League,
                    Role.Team,
                    Role.CombineBallotUser,
                    Role.DraftGreenRoomBallotUser,
                  ]}
                  combineResultsFlag={combineResultsFlag}
                />
              }
            >
              {" "}
              <Route
                path={`/:eventId${RouteConstants.CAREER_STATS}`}
                element={<ComparableDashboard />}
              />
            </Route>

            {/* <Route
              path={RouteConstants.COMBINE_RESULTS}
              element={
                isAdmin ||
                (RoutePermissions.IsAuthorized(
                  RouteScreens.CombineResults,
                  userAppRoles
                ) &&
                  playerProfileFlag) ? (
                  <CombineResults />
                ) : (
                  unauthorized()
                )
              }
            ></Route> */}

            <Route
              exact
              path={RouteConstants.MANAGE_PLAYER_CAREER_STATS}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                exact
                path={RouteConstants.MANAGE_PLAYER_CAREER_STATS}
                element={<ManagePlayerCareerStatsContainer />}
              />
            </Route>

            <Route
              path={RouteConstants.USER_PREFERENCES}
              element={
                <PrivateRoute roles={[Role.Admin, Role.League, Role.Team]} />
              }
            >
              <Route
                exact
                path={RouteConstants.USER_PREFERENCES}
                element={<ManageUserPreferences />}
              />
            </Route>

            <Route
              exact
              path={RouteConstants.REVISED_GAME_AUDIT}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                exact
                path={RouteConstants.REVISED_GAME_AUDIT}
                element={<RevisedGameAuditContainer />}
              />
            </Route>

            {/* Box Score Dashboard Route */}
            <Route
              path={`${RouteConstants.BOX_SCORE}`}
              element={<PrivateRoute roles={Role.AvailableRoles} />}
            >
              <Route
                path={`${RouteConstants.BOX_SCORE}`}
                element={<GameScoreDashboard />}
              />
            </Route>

            <Route
              path={`${RouteConstants.MANAGE_EMAIL_NOTIFICATION}`}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={`${RouteConstants.MANAGE_EMAIL_NOTIFICATION}`}
                element={<ManageEmailNotification />}
              />
            </Route>

            <Route
              path={`${RouteConstants.EMAIL_NOTIFICATION}/:notificationID`}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={`${RouteConstants.EMAIL_NOTIFICATION}/:notificationID`}
                element={<EmailNotification />}
              />
            </Route>

            <Route
              path={`${RouteConstants.VIEW_EMAIL_NOTIFICATION}/:notificationID`}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={`${RouteConstants.VIEW_EMAIL_NOTIFICATION}/:notificationID`}
                element={<ViewEmailNotification />}
              />
            </Route>

            <Route
              path={RouteConstants.TEAM_TOP_FIVE_BALLOT_VOTE}
              element={
                <PrivateRoute roles={[Role.DraftGLeagueBallotVoteUser]} />
              }
            >
              <Route
                path={RouteConstants.TEAM_TOP_FIVE_BALLOT_VOTE}
                element={<GLeagueBallot />}
              />
            </Route>

            <Route
              path={`${RouteConstants.MANAGE_TEAM_PLAYERS}`}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                path={`${RouteConstants.MANAGE_TEAM_PLAYERS}`}
                element={<ManageTeamPlayersContainer />}
              />
            </Route>

            <Route
              path={`${RouteConstants.EVENT_SCHEDULER}`}
              element={<PrivateRoute roles={Role.AvailableRoles} />}
            >
              <Route
                path={`${RouteConstants.EVENT_SCHEDULER}`}
                element={<EventScheduleContainer />}
              />
            </Route>

            <Route
              path={`${RouteConstants.VIEW_TEAM_ROSTER}`}
              element={<PrivateRoute roles={Role.AvailableRoles} />}
            >
              <Route
                path={`${RouteConstants.VIEW_TEAM_ROSTER}`}
                element={<ViewTeamRoster />}
              />
            </Route>

            <Route
              path={`${RouteConstants.USER_MANAGEMENT}`}
              element={<PrivateRoute roles={[Role.Admin]} />}
            >
              <Route
                exact
                path={RouteConstants.USER_MANAGEMENT}
                element={<UserManagementContainer />}
              />
            </Route>

            <Route
              path={`${RouteConstants.FIVE_ON_FIVE_MANAGEMENT}`}
              element={<PrivateRoute roles={Role.AvailableRoles} />}
            >
              <Route
                path={`${RouteConstants.FIVE_ON_FIVE_MANAGEMENT}`}
                element={<Manage5On5GamesContainer />}
              />
            </Route>

            <Route
              exact
              path={RouteConstants.UNAUTHORIZED}
              element={<Unauthorized />}
            />
          </Routes>
        </div>
        <SidebarMenu open={openSideMenu} toggleDrawer={toggleDrawer} />
        {/* </> */}
        {/* )} */}
      </Router>
    </div>
    // </ApolloProvider>
  );
};
//... Setting colors for the light and dark theme.
function getTheme(theme) {
  return createTheme({
    palette: {
      type: theme.paletteType,
      primary: {
        main: theme.paletteType === "light" ? "#1d428a" : "#90caf9",
        //light: (theme.paletteType === 'light') ? '#8797bf' : '#a6d4fa',
        dark: theme.paletteType === "light" ? "#172b5b" : "#648dae",
      },
      secondary: {
        main: theme.paletteType === "light" ? "#c8102e" : "#f48fb1",
      },
    },

    overrides: {
      MuiTooltip: {
        tooltip: {
          fontSize: ".75rem",
          fontWeight: "normal",
        },
      },
    },
  });
}
export default App;
